const Header = {
  init: () => {
    // activate submenus
    Header.initSubMenus();

    // get mobile nav btn
    const btn = document.getElementById("header__btn");

    // mobile nav toggle
    if (btn) {
      btn.addEventListener("click", function () {
        // get btn aria labels
        const labelOpen = btn.dataset.ariaLabelOpen;
        const labelClose = btn.dataset.ariaLabelClose;

        // get btn text values
        const textOpen = btn.dataset.textOpen ? btn.dataset.textOpen : "Meny";
        const textClose = btn.dataset.textClose
          ? btn.dataset.textClose
          : "Stäng";

        // get btn inner text span element
        const btnText = btn.querySelector(".button__text");

        // toggle aria expanded attr
        let isExpanded = btn.getAttribute("aria-expanded") === "true" || false;
        btn.setAttribute("aria-expanded", !isExpanded);

        // toggle aria labels
        if (!isExpanded) {
          btn.setAttribute("aria-label", labelClose);
          if (btnText) btnText.textContent = textClose;
        } else {
          btn.setAttribute("aria-label", labelOpen);
          if (btnText) btnText.textContent = textOpen;
        }
      });
    }
  },

  initSubMenus: () => {
    // get every nav item that has sub-menus
    const parentNavItems = Array.from(
      document.querySelectorAll(".menu-item-has-children"),
    );

    // check if any nodes was found
    if (parentNavItems) {
      // set aria-expanded attr
      parentNavItems.map((item) => {
        item.setAttribute("aria-expanded", "false");

        // add listener for toggle on parent items
        item.addEventListener("click", function () {
          let expanded = item.getAttribute("aria-expanded") === "true" || false;
          item.setAttribute("aria-expanded", !expanded);
        });
      });
    }
  },
};

export default Header;
